import {BsPeople,BsFillHouseDoorFill} from 'react-icons/bs';

const ProfileCard = ({user}) => {
    const design = (
        <>
        <div className="card-container">
            <div className="top-left-image">
                <img src="tiffin.png" alt="Image Icon" />
            </div>
            <div className="card-content">
                <div className="name">{user.name.toLowerCase()}</div>
                <div className="numbers">
                <span>ITS : {user.hof}</span>
                <span>|</span>
                <span>Sabeel : {user.sabeel}</span>
                </div>
                <div className="small-numbers">
                <div className="text">
                <span style={{fontSize:'16px',fontWeight:'bold',color:'black'}}><BsFillHouseDoorFill /> {user.block} </span>
                    <p>Flat No</p>
                </div>
                <div className="text">
                    <span  style={{fontSize:'16px',fontWeight:'bold',color:'black'}}><BsPeople className='mx-1' /> {user.members} </span>
                    <p>Members</p>
                </div>
                </div>
            </div>
        </div>
        </>
    )
    return design;
}

export default ProfileCard;